import React from 'react'
import { connectHits } from 'react-instantsearch/connectors'
import getClassification from '../../utils/getClassification'
import Cards from './Cards'

const RenderResults = ({ hit }) => <Cards {...{ hit, key: hit.universal_id, classification: getClassification(hit) }} />

export default connectHits(RenderResults)
